import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import "./App.css";

// Pages
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Explore from "./pages/Explore";
import CreateRoom from "./pages/CreateRoom";
import Profile from "./pages/Profile";
import RoomView from "./pages/RoomView";

// Contexts
import { AuthProvider } from "./contexts/AuthContext";
import { RoomProvider } from "./contexts/RoomContext";
import { ChatProvider } from "./contexts/ChatContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { AIProvider } from "./contexts/AIContext";

// Components
import MainLayout from "./components/layout/MainLayout";
import ProtectedRoute from "./components/common/ProtectedRoute";
import ProjectAgent from "./components/ProjectAgent/ProjectAgent";

function App() {
  return (
    <Router>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ThemeProvider>
          <AuthProvider>
            <RoomProvider>
              <NotificationProvider>
                <AIProvider>
                  <ChatProvider>
                    <Routes>
                      {/* Public Routes */}
                      <Route path="/login" element={<Login />} />
                      <Route path="/register" element={<Register />} />

                      {/* Protected Routes */}
                      <Route
                        path="/dashboard"
                        element={
                          <ProtectedRoute>
                            <MainLayout>
                              <Dashboard />
                            </MainLayout>
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/explore"
                        element={
                          <ProtectedRoute>
                            <MainLayout>
                              <Explore />
                            </MainLayout>
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/create-room"
                        element={
                          <ProtectedRoute>
                            <MainLayout>
                              <CreateRoom />
                            </MainLayout>
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/profile"
                        element={
                          <ProtectedRoute>
                            <MainLayout>
                              <Profile />
                            </MainLayout>
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/room/:roomId"
                        element={
                          <ProtectedRoute>
                            <MainLayout>
                              <RoomView />
                            </MainLayout>
                          </ProtectedRoute>
                        }
                      />
                      {/* Add a route alias for backward compatibility */}
                      <Route
                        path="/rooms/:roomId"
                        element={
                          <ProtectedRoute>
                            <MainLayout>
                              <RoomView />
                            </MainLayout>
                          </ProtectedRoute>
                        }
                      />

                      {/* Default Redirect */}
                      <Route
                        path="/"
                        element={<Navigate to="/login" replace />}
                      />
                      <Route
                        path="*"
                        element={<Navigate to="/login" replace />}
                      />
                    </Routes>
                    <ProjectAgent />
                  </ChatProvider>
                </AIProvider>
              </NotificationProvider>
            </RoomProvider>
          </AuthProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </Router >
  );
}

export default App;
